import React, { useEffect } from "react";
import "./index.css";

interface PropType {
  show: boolean;
  closeModal: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  content: JSX.Element;
  onKeydown?: () => void;
}

const Modal: React.FunctionComponent<PropType> = (props: PropType) => {
  const { show, closeModal, content, onKeydown } = props;

  const addBodyClass = (className: string): void =>
    document.body.classList.add(className);
  const removeBodyClass = (className: string): void =>
    document.body.classList.remove(className);

  useEffect(() => {
    if (!show) {
      removeBodyClass("overflow-hidden");
      return;
    }
    addBodyClass("overflow-hidden");
  }, [show]);

  return (
    <>
      <div
        className={`${
          show ? "overlay" : "hide"
        } opacity-25 fixed inset-0 bg-black z-30`}
        // onClick={closeModal} Todo: removing close on outside click
        onKeyDown={onKeydown}
        tabIndex={0}
        role="button"
      >
        <span />{" "}
      </div>
      <div
        className={`${
          show ? "overlay" : "hide"
        } justify-center items-center  overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none `}
      >
        <div className="justify-center max-w-4xl mt-12 mx-auto my-6 relative flex">
          <div className="border-0 rounded-md shadow-lg relative inline-block flex-col bg-white outline-none focus:outline-none">
            <div className="relative flex-auto">{content}</div>
          </div>
        </div>
      </div>
    </>
  );
};

Modal.defaultProps = {
  onKeydown: (): void => {
    //
  },
};

export default Modal;
